<template>
  <div class="view-detail__wrapper">
    <div class="view-detail__header">
      <div
        @click="$emit('hide')"
        class="cursor-pointer"
      >
        <aha-icon name="arrow-left" />
      </div>
      <p class="text-sm text-secondary-100">
        <aha-icon
          name="info-circle"
          class="text-base-70 mt-0.5"
          viewBox="0 0 24 24"
          width="22"
          height="22"
        />
        View detail
      </p>
      <div>
      </div>
    </div>
    <div class="view-detail__body">
      <div class="body__table--wrapper">
        <div class="body__table-content">
          <table class="w-full">
            <tbody>
              <tr>
                <td class="font-bold">
                  Name
                </td>
                <td class="text-right">
                  {{ member.firstName }} {{ member.lastName }}
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  Email
                </td>
                <td class="text-right">
                  {{ member.email }}
                </td>
              </tr>
              <tr v-if="showAllDetail">
                <td class="font-bold">
                  Last activity
                </td>
                <td class="text-right">
                  {{ member.lastActivity | dateTimeAgo }}
                </td>
              </tr>
              <tr v-if="showAllDetail">
                <td class="font-bold">
                  Usage
                </td>
                <td class="text-right">
                  {{ member.usage }}
                </td>
              </tr>
              <tr v-if="showAllDetail">
                <td class="font-bold">
                  Joined
                </td>
                <td class="text-right">
                  <span v-if="member.accountData">
                    {{ member.accountData.joinedAt | dateTimeAgo }}
                  </span>
                  <span v-else>{{ $store.state.currentUser.createdAt | dateTimeAgo }}</span>
                </td>
              </tr>
              <tr v-if="!isSelfCreateTeam">
                <td class="font-bold">
                  Expires
                </td>
                <td class="text-right">
                  {{ expiryInfo | dateTimeStamp }}
                </td>
              </tr>
              <tr>
                <td class="font-bold">
                  Role
                </td>
                <td class="text-right">
                  <aha-pill-badge
                    :label="member.role"
                    size="sm"
                    class="inline"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    member: {
      type: Object,
      default: () => {},
    },
    expiryInfo: {
      type: String,
      default: null,
    },
    showAllDetail: {
      type: Boolean,
      default: false,
    },
    isSelfCreateTeam: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.view-detail__wrapper {
  @apply absolute top-0 z-10 bg-primary-50 h-screen;
  @apply flex flex-col w-full;
}

.view-detail__header {
  @apply p-4 text-base-90;
  @apply w-full flex justify-between shadow-top bg-base-0;
  z-index: 1;
}

.view-detail__body {
 @apply bg-primary-50;
 @apply flex justify-center w-full;
 .body__table--wrapper {
   @apply bg-base-0;
   @apply m-5 w-full border-collapse rounded-lg;
 }
}

.body__table-content {
  @apply py-3 px-4 rounded-lg shadow;
  td {
    @apply py-2 break-words;
  }
}
</style>
